// extracted by mini-css-extract-plugin
module.exports = {"Photos__row":"ia_a pz_a pz_r pz_j","Photos__img":"ia_b pz_b"};